/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Schoolname_Karl_Theodor_Von_Dalberg_Gymnasium5Inputs */

const en__field__enum_schoolname_karl_theodor_von_dalberg_gymnasium5 = /** @type {(inputs: _Field__Enum_Schoolname_Karl_Theodor_Von_Dalberg_Gymnasium5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aschaffenburg`)
};

const de__field__enum_schoolname_karl_theodor_von_dalberg_gymnasium5 = /** @type {(inputs: _Field__Enum_Schoolname_Karl_Theodor_Von_Dalberg_Gymnasium5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karl-Theodor-von-Dalberg-Gymnasium`)
};

/**
* | output |
* | --- |
* | "Aschaffenburg" |
*
* @param {_Field__Enum_Schoolname_Karl_Theodor_Von_Dalberg_Gymnasium5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_schoolname_karl_theodor_von_dalberg_gymnasium5 = /** @type {((inputs?: _Field__Enum_Schoolname_Karl_Theodor_Von_Dalberg_Gymnasium5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Schoolname_Karl_Theodor_Von_Dalberg_Gymnasium5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_schoolname_karl_theodor_von_dalberg_gymnasium5(inputs)
	return de__field__enum_schoolname_karl_theodor_von_dalberg_gymnasium5(inputs)
});
export { _field__enum_schoolname_karl_theodor_von_dalberg_gymnasium5 as "_field__enum_schoolName_Karl_Theodor_von_Dalberg_Gymnasium" }